import React from 'react';
import {Container} from '@material-ui/core';
import {FirebaseContext} from '../../Firebase';
import {Button, TextField} from '@material-ui/core';
import ReactGoogleSlides from 'react-google-slides';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

const Session10 = () => {
  const firebase = React.useContext(FirebaseContext);
  const group = firebase.userData.group;
  const [scr, setScr] = React.useState(0);
  const [CR, setCR] = React.useState(false);
  const [response, setResponse] = React.useState('');
  const [resp1, setResp1] = React.useState('');
  const [resp2, setResp2] = React.useState('');
  const [resp3, setResp3] = React.useState('');
  return (
    <div>
      <Container
        style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          minHeight: '270px',
        }}
      >
        {/* SCREENS INTRO ALL GROUP*/}
        {scr === 0 && (
          <div>
            <h3>Bonjour et bienvenue !</h3>
            <p>
              Aujourd’hui, nous continuons notre découverte de l’entraide dans
              les classes et dans les associations.
            </p>
            <p>
              Clique sur le bouton continuer une fois que tu as bien compris
              pour continuer.
            </p>
          </div>
        )}
        {scr === 1 && (
          <div style={{textAlign: 'center', width: '100%'}}>
            <ReactGoogleSlides
              width={'100%'}
              height={480}
              slidesLink="https://docs.google.com/presentation/d/1bvM79NiOrUAAG08oBZjkiXD359JzuujSNS7_8K8B6CU"
              position={0}
              showControls
            />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend">
                Les jeunes bénévoles de la vidéo ont décidé de s’engager pour la
                cause :
              </FormLabel>
              <RadioGroup
                aria-label="team"
                defaultValue=""
                name="radio-buttons-group-team"
                onChange={(e) => {
                  setCR(true);
                  setResponse(e.target.value);
                }}
              >
                <FormControlLabel
                  value="protectAnimaux"
                  control={<Radio />}
                  label="De la protection des animaux"
                />
                <FormControlLabel
                  value="PropreteLittoral"
                  control={<Radio />}
                  label="De la propreté du littoral"
                />
                <FormControlLabel
                  value="sauvegardePapillon"
                  control={<Radio />}
                  label="De la sauvegarde des papillons"
                />
              </RadioGroup>
            </FormControl>
          </div>
        )}
        {/* SCREENS CONTROL*/}
        {group.toString() === 'control' && scr === 2 && (
          <div>
            <p>
              Lors de la dernière séance, tu avais commencé à réfléchir à
              l’organisation d’un spectacle pour une classe d’enfants de CP.
            </p>
            <p>
              Ces enfants ont quelques questions pour toi… à toi d’y répondre !
            </p>
          </div>
        )}
        {group.toString() === 'control' && scr === 3 && (
          <div>
            <p>
              Question 1 : Est-ce que toute la classe aura un rôle ? Qu’est-ce
              qu’il y a comme rôles différents ?{' '}
            </p>
            <TextField
              fullWidth
              rows="4"
              label="Ta réponse"
              variant="outlined"
              value={resp1}
              onChange={(e) => {
                setResp1(e.target.value);
              }}
            />
            <p>
              Question 2 : Est-ce que tu as prévu des costumes ? Ils seront
              comment ?{' '}
            </p>
            <TextField
              fullWidth
              rows="4"
              label="Ta réponse"
              variant="outlined"
              value={resp2}
              onChange={(e) => {
                setResp2(e.target.value);
              }}
            />
            <p>
              Question 3 : Il faut qu’on apprenne des textes ou des chansons ?
              Est-ce que ce sera long ?{' '}
            </p>

            <TextField
              fullWidth
              rows="4"
              label="Ta réponse"
              variant="outlined"
              value={resp3}
              onChange={(e) => {
                setResp3(e.target.value);
              }}
            />

            <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
          </div>
        )}
        {group.toString() === 'control' && scr === 4 && (
          <div>
            <p>Nous avons terminé pour aujourd’hui.</p>
            <p>
              Rendez-vous à la prochaine session pour continuer l’organisation
              de ce spectacle. N’oublie pas de te connecter dans quelques jours
              pour la prochaine séance !
            </p>
            <p>Merci pour ta participation !</p>
            <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
          </div>
        )}
        {/* SCREENS TEST*/}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 2 && (
            <div>
              <p>
                Lors de la dernière séance, tu avais écrit une présentation de
                ton action bénévole pour une classe d’enfants de CP.
              </p>
              <p>
                Ils ont trouvé ta présentation très intéressante et ont quelques
                questions pour toi… à toi d’y répondre !
              </p>
              <p>Continuons !</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 3 && (
            <div>
              {group.toString() === 'test_a' && (
                <p>
                  Question 1 : Pourquoi as-tu choisi le thème de l’écologie ?
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  Question 1 : Pourquoi as-tu choisi le thème du soutien aux
                  personnes à l’hôpital ?
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  Question 1 : Pourquoi as-tu choisi le thème du soutien aux
                  personnes en situation de pauvreté ?
                </p>
              )}

              <TextField
                fullWidth
                rows="4"
                label="Ta réponse"
                variant="outlined"
                value={resp1}
                onChange={(e) => {
                  setResp1(e.target.value);
                }}
              />
              {group.toString() === 'test_a' && (
                <p>
                  Question 2 : Pourquoi c’est important d’aider la planète ?
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  Question 2 : Pourquoi c’est important d’aider les autres ?
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  Question 2 : Pourquoi c’est important d’aider les autres ?
                </p>
              )}

              <TextField
                fullWidth
                rows="4"
                label="Ta réponse"
                variant="outlined"
                value={resp2}
                onChange={(e) => {
                  setResp2(e.target.value);
                }}
              />
              {group.toString() === 'test_a' && (
                <p>
                  Question 3 : Est-ce qu’on peut être bénévole toute sa vie ?
                </p>
              )}
              {group.toString() === 'test_b' && (
                <p>
                  Question 3 : Est-ce qu’on peut être bénévole toute sa vie ?
                </p>
              )}
              {group.toString() === 'test_c' && (
                <p>
                  Question 3 : Est-ce qu’on peut être bénévole toute sa vie ?
                </p>
              )}

              <TextField
                fullWidth
                rows="4"
                label="Ta réponse"
                variant="outlined"
                value={resp3}
                onChange={(e) => {
                  setResp3(e.target.value);
                }}
              />

              <p>Quand tu as terminé, clique sur le bouton ci-dessous.</p>
            </div>
          )}
        {(group.toString() === 'test_a' ||
          group.toString() === 'test_b' ||
          group.toString() === 'test_c') &&
          scr === 4 && (
            <div>
              <p>
                Nous avons terminé pour aujourd’hui. Lors de la prochaine
                session, les élèves de la classe de CP te poseront des questions
                auxquelles tu pourras répondre. N’oublie pas de te connecter
                dans quelques jours pour la prochaine séance !
              </p>
              <p>Merci pour ta participation !</p>
              <p>Clique sur le bouton ci-dessous pour quitter la séance.</p>
            </div>
          )}
      </Container>
      {/* BUTTON*/}
      <Button
        style={{display: 'block', margin: 'auto'}}
        disabled={scr === 1 && !CR}
        variant="contained"
        color="primary"
        onClick={() => {
          if (scr === 3) {
            // save TEST DATA
            let now = new Date();
            firebase
              .databehav(firebase.userData.pseudo)
              .collection('session10')
              .add({
                date: now,
                response: response,
                resp1: resp1,
                resp2: resp2,
                resp3: resp3,
              })
              .catch((error) => {
                console.log(error);
              });
          }
          if (scr === 4) {
            firebase.signoutUser();
          } else {
            setScr(scr + 1);
          }
        }}
      >
        Continuer
      </Button>
    </div>
  );
};
export default Session10;
